module.exports = __webpack_public_path__ + "static/media/choithramsJohnsonBabyS.1eeec733.png";